const initProductBestsellers = (root = document) => {
  root.querySelectorAll('[data-product-bestsellers]').forEach((section) => {
    const element = section.querySelector('.swiper');
    if (element.swiper || !window.Swiper) return;
    new Swiper(element, {
      slidesPerView: 'auto',
      spaceBetween: 6,
      watchOverflow: true,
      speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
      slidesOffsetAfter: 6,
      navigation: {
        prevEl: section.querySelector('.bestsellers__arrow--left'),
        nextEl: section.querySelector('.bestsellers__arrow--right'),
      },

      pagination: {
        el: '.bestsellers__dots',
        clickable: true,
        bulletElement: 'button',
        bulletClass: 'bestsellers__dot',
        bulletActiveClass: 'bestsellers__dot--active',
      },
      a11y: {
        prevSlideMessage: section.querySelector('.bestsellers__arrow--left')?.getAttribute('aria-label'),
        nextSlideMessage: section.querySelector('.bestsellers__arrow--right')?.getAttribute('aria-label'),
        firstSlideMessage: section.querySelector('.bestsellers__arrow--left')?.getAttribute('aria-label'),
        lastSlideMessage: section.querySelector('.bestsellers__arrow--right')?.getAttribute('aria-label'),
      },
    });
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductBestsellers(), { once: true });
} else {
  initProductBestsellers();
}
document.addEventListener('shopify:section:load', (event) => initProductBestsellers(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelector('[data-product-bestsellers] .swiper')?.swiper?.destroy(true, true);
});
document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest('[data-product-bestsellers] .swiper-slide');
  const swiper = slide?.closest('.swiper')?.swiper;
  if (swiper) swiper.slideTo(swiper.slides.indexOf(slide), 0);
});
